import script from "./name.vue?vue&type=script&setup=true&lang=ts"
export * from "./name.vue?vue&type=script&setup=true&lang=ts"

import "./name.vue?vue&type=style&index=0&id=2975e666&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2975e666"]])

export default __exports__